import { render } from "./TheChangeProfile.vue?vue&type=template&id=6e31cf3e"
import script from "./TheChangeProfile.vue?vue&type=script&lang=js"
export * from "./TheChangeProfile.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__